import { call, select } from "redux-saga/effects";
import { TempIdsMap } from "../../../../api/api-slice";
import { selectComponentTempIdsMap } from "../../../../api/selectors";
import ComponentsService from "../../../../../services/ComponentsService";
import { IUpdateComponentCommand } from "@growth-machine-llc/stridist-api-client";
import { CurriculumComponent } from "../../../../types";

export default function* updateComponentPropsWorker(payload: {
  componentId: number;
  data: Partial<CurriculumComponent>;
  apiHandled?: boolean;
}) {
  const { componentId, data, apiHandled } = payload;
  if (apiHandled) {
    return;
  }
  const map: TempIdsMap = yield select(selectComponentTempIdsMap);
  const checkedComponentId = map?.[componentId] || componentId;

  const command: IUpdateComponentCommand = {
    id: checkedComponentId,
    ...data,
  };

  try {
    yield call(ComponentsService.update, command);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
